import React from 'react';
import { Typography, Box } from '@mui/material';

const TitleCase = props => {
    // function titleCase(str) {
    //     str = str.toLowerCase();
    //     str = str.split(' ');
    //     for (var i = 0; i < str.length; i++) {
    //         str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    //         return str.join(' ');
    //     }
    // }

    const camelCase = text => {
        return text.replace(/(^|\W)[a-z]/g, letter => {
            return letter.toUpperCase();
        });
    };

    return (
        <Box>
            {typeof props.string === 'string' && (
                <Typography
                    variant={props.variant}
                    sx={props.sx}
                    data-cy={
                        props.hasOwnProperty('data-cy') ? props['data-cy'] : ''
                    }
                >
                    {camelCase(props.string)}
                </Typography>
            )}
        </Box>
    );
};

export default TitleCase;
